
import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { VIRTUAL_SECURITY_TYPE } from "../../helper/licenseHelper";
import { useAllProducts } from "../../hooks/useAllProduts";


type ProductsFilterProps = {
  onChange: (value: string[]) => void;
  value?: string[];
};


export const AllProductSelect: React.FC<ProductsFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const allProducts = useAllProducts();

  //const {roles} = useRolesContext();
  // let searchAccessFilterListArray: string[] =[]; 
  // searchAccessFilterListArray = roles?.VIRTUAL_SECURITY_SEARCH_ACCESS_LIST_FILTER_LIST?.toString()?.split(",") ?? [];
  // searchAccessFilterListArray = searchAccessFilterListArray.map((value)=>(value.trim()))

  const products = allProducts?.products.filter((p) => p.security_type === VIRTUAL_SECURITY_TYPE)

  const productsOptions = products.map(
    (product) => ({
      value: product.code,
      label: product.name,
    })
  );

  return (
    <Select
      mode="multiple"
      allowClear
      placeholder={t("licenses.basic.search.product.title")}
      style={{ width: "100%" }}
      maxTagCount={1}
      options={productsOptions}
      onChange={onChange}
      value={value}
    />
  );
};

